(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["c-collection"] && !Shopify.designMode) return;
  try {
    
/* ===========================================================================
   Section script — enhancement only, never a requirement
   ===========================================================================

   Everything this file does already works without it: the filters are a GET
   form with a real Apply button, and "Load more" is a real link to the next
   page. A share of this store's visitors have every script stripped before it
   runs (see AGENTS.md), so nothing here may be load-bearing.

   Adding `is-js-ready` to the section is the signal the CSS waits for to hide
   the Apply button. If this file never runs, the button stays and the filters
   keep working the slow way.
   =========================================================================== */

(function () {
  'use strict';

  function initSection(section) {
    if (section.dataset.cCollectionReady === 'true') return;
    section.dataset.cCollectionReady = 'true';
    section.classList.add('is-js-ready');

    initFilters(section);
    initLoadMore(section);
    initReviewsProgress(section);
  }

  /* Swaps one element's markup for the matching one in a fetched document. */
  function swap(section, doc, selector) {
    var current = section.querySelector(selector);
    var next = doc.querySelector(selector);
    if (!current) return;
    if (next) {
      current.innerHTML = next.innerHTML;
    } else {
      current.remove();
    }
  }

  /* "Apply (N)" — Figma 1177:3638. The base label stays in `data-base-text`
     so this only ever adds to it, never guesses at the original copy. */
  function updateApplyCount(section) {
    var button = section.querySelector('.c-collection__apply');
    if (!button) return;
    var base = button.dataset.baseText || button.textContent.trim();
    var checked = section.querySelectorAll('.c-collection-filter__input:checked').length;
    button.textContent = checked > 0 ? base + ' (' + checked + ')' : base;
  }

  /* Filters and sorting update the grid in place. The form still works on its
     own if this never runs — it is a real GET form carrying the `view` param,
     so submitting it lands on the same template with the filters applied. */
  function initFilters(section) {
    var form = section.querySelector('.c-collection__filters');
    if (!form) return;

    updateApplyCount(section);

    function apply() {
      /* FormData picks up the sort <select> too: it lives in the toolbar but
         is bound to this form through its `form` attribute. */
      var query = new URLSearchParams(new FormData(form)).toString();
      var url = window.location.pathname + (query ? '?' + query : '');

      section.setAttribute('aria-busy', 'true');

      fetch(url)
        .then(function (response) {
          if (!response.ok) throw new Error('HTTP ' + response.status);
          return response.text();
        })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          if (!doc.querySelector('.c-collection__grid')) throw new Error('no grid');

          swap(section, doc, '.c-collection__grid');
          swap(section, doc, '.c-collection__filters');
          swap(section, doc, '.c-collection__toolbar');
          swap(section, doc, '.c-collection__more');

          updateApplyCount(section);
          initReviewsProgress(section);
          section.removeAttribute('aria-busy');
          if (window.history && window.history.pushState) {
            window.history.pushState({}, '', url);
          }
        })
        .catch(function () {
          /* Hand the navigation back rather than leaving stale results up. */
          window.location.href = url;
        });
    }

    /* One listener on the section catches both the sidebar checkboxes and the
       sort dropdown, which sits outside the form. */
    section.addEventListener('change', function (event) {
      if (event.target.closest('.c-collection__filters') || event.target.name === 'sort_by') {
        if (event.target.classList.contains('c-collection-filter__input')) {
          updateApplyCount(section);
        }
        apply();
      }
    });

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      apply();
    });
  }

  /* Turns the pagination link into an append-in-place button. On any failure
     it steps out of the way and lets the browser follow the href. */
  function initLoadMore(section) {
    /* Delegated, because filtering replaces the whole "load more" block and a
       listener bound straight to the button would go with it. */
    section.addEventListener('click', function (event) {
      var button = event.target.closest('.c-collection__more-btn');
      if (!button || !section.contains(button)) return;

      var grid = section.querySelector('.c-collection__grid');
      if (!grid) return;

      var url = button.getAttribute('href');
      if (!url) return;

      event.preventDefault();
      button.setAttribute('aria-busy', 'true');

      fetch(url)
        .then(function (response) {
          if (!response.ok) throw new Error('HTTP ' + response.status);
          return response.text();
        })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var nextGrid = doc.querySelector('#' + CSS.escape(grid.id));
          var nextButton = doc.querySelector('.c-collection__more-btn');
          var nextShowing = doc.querySelector('.c-collection__showing');
          if (!nextGrid) throw new Error('no grid in response');

          while (nextGrid.firstElementChild) {
            grid.appendChild(nextGrid.firstElementChild);
          }

          var showing = section.querySelector('.c-collection__showing');
          if (showing && nextShowing) showing.textContent = nextShowing.textContent;

          if (nextButton) {
            button.setAttribute('href', nextButton.getAttribute('href'));
            button.removeAttribute('aria-busy');
          } else {
            button.remove();
          }

          if (window.history && window.history.replaceState) {
            window.history.replaceState({}, '', url);
          }
        })
        .catch(function () {
          /* Give the link back to the browser rather than trapping anyone. */
          button.removeAttribute('aria-busy');
          window.location.href = url;
        });
    });
  }

  /* Figma 1110:1633 — reads the review rail's own scroll position back onto
     the track underneath it. Same width+translateX math as the PDP reviews
     slider's `.c-pdp-progress` (c-pdp-reviews.liquid), applied here to
     `.c-collection__reviews` instead. Re-run after every filter swap: that
     replaces `.c-collection__grid`, which is where the rail and its track
     both live, so any listener bound to the old rail goes with it. */
  function initReviewsProgress(section) {
    var rail = section.querySelector('.c-collection__reviews');
    var fill = section.querySelector('.c-collection__reviews-progress-fill');
    if (!rail || !fill) return;

    function sync() {
      var max = rail.scrollWidth - rail.clientWidth;
      var ratio = max <= 1 ? 0 : rail.scrollLeft / max;
      var visible = Math.max(rail.clientWidth / rail.scrollWidth, 0.12);
      fill.style.width = visible * 100 + '%';
      fill.style.transform = 'translateX(' + ratio * (100 / visible - 100) + '%)';
    }

    rail.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync);
    sync();
  }

  function initAll() {
    document.querySelectorAll('[data-sl-id="c-collection"]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  /* The theme editor re-renders sections in place. */
  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.querySelector('[data-sl-id="c-collection"]');
    if (section) initSection(section);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["c-reviews"] && !Shopify.designMode) return;
  try {
    
/* ===========================================================================
   Section script — enhancement only
   ===========================================================================

   Two unrelated jobs:

   1. Filter our own review cards by topic. The pills stay hidden until this
      runs, so a visitor whose scripts were stripped sees every card rather
      than a row of buttons that do nothing.

   2. Tidy the Shopper Approved summary. The widget prints its share as
      "(85.94%)" next to a raw count; CSS can hide the count but cannot rewrite
      the string, so the percentage is reformatted here.

   Nothing below is load-bearing: without it the cards all show and the summary
   simply keeps the widget's own wording.
   =========================================================================== */

(function () {
  'use strict';

  var WAIT_MS = 15000;

  function initSection(section) {
    if (section.dataset.cReviewsReady === 'true') return;
    section.dataset.cReviewsReady = 'true';

    initFilter(section);
    initSwiper(section);
    whenSummaryReady(section, normalisePercentages);
  }

  /* --- swiper --------------------------------------------------------------
     The rail already swipes on touch and takes arrow keys as a scroll-snap
     track. This adds what a mouse needs — arrows, a progress bar and
     grab-to-drag — and none of it is load-bearing: the controls are hidden
     until `is-js-ready`, which `initFilter` sets.
     ---------------------------------------------------------------------- */

  var DRAG_THRESHOLD = 5;

  function initSwiper(section) {
    var rail = section.querySelector('[data-reviews-rail]');
    if (!rail) return;

    var bar = section.querySelector('[data-reviews-bar]');
    var prev = section.querySelector('[data-reviews-prev]');
    var next = section.querySelector('[data-reviews-next]');

    function step() {
      var first = rail.querySelector('.c-reviews-card:not([hidden])');
      if (!first) return rail.clientWidth;
      var gap = parseFloat(getComputedStyle(rail).columnGap) || 0;
      return first.getBoundingClientRect().width + gap;
    }

    function sync() {
      var max = rail.scrollWidth - rail.clientWidth;
      var ratio = max <= 1 ? 1 : rail.scrollLeft / max;
      var visible = Math.max(rail.clientWidth / rail.scrollWidth, 0.12);
      if (bar) {
        bar.style.width = visible * 100 + '%';
        bar.style.transform = 'translateX(' + ratio * (100 / visible - 100) + '%)';
      }
      /* With nothing to scroll — three cards on a wide screen, or a filter
         that left one — both arrows go inert rather than lying. */
      if (prev) prev.disabled = max <= 1 || rail.scrollLeft <= 1;
      if (next) next.disabled = max <= 1 || rail.scrollLeft >= max - 1;
    }

    section.cReviewsSyncSwiper = sync;

    if (prev) prev.addEventListener('click', function () {
      rail.scrollBy({ left: -step(), behavior: 'smooth' });
    });
    if (next) next.addEventListener('click', function () {
      rail.scrollBy({ left: step(), behavior: 'smooth' });
    });

    rail.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync);
    sync();

    /* Touch swipes natively; this is the mouse equivalent. */
    var down = false, moved = false, startX = 0, startScroll = 0;
    rail.classList.add('is-draggable');

    rail.addEventListener('pointerdown', function (event) {
      if (event.pointerType === 'touch' || event.button !== 0) return;
      down = true; moved = false;
      startX = event.clientX;
      startScroll = rail.scrollLeft;
    });

    rail.addEventListener('pointermove', function (event) {
      if (!down) return;
      var delta = event.clientX - startX;
      if (!moved && Math.abs(delta) < DRAG_THRESHOLD) return;
      moved = true;
      rail.classList.add('is-dragging');
      rail.scrollLeft = startScroll - delta;
    });

    function release() {
      down = false;
      rail.classList.remove('is-dragging');
    }

    rail.addEventListener('pointerup', release);
    rail.addEventListener('pointercancel', release);
    rail.addEventListener('pointerleave', release);
  }

  /* --- topic filter --------------------------------------------------------- */

  function initFilter(section) {
    var pills = section.querySelector('[data-reviews-pills]');
    var rail = section.querySelector('[data-reviews-rail]');
    if (!pills || !rail) return;

    var cards = [].slice.call(rail.querySelectorAll('.c-reviews-card'));
    var empty = rail.querySelector('[data-reviews-empty]');
    var all = pills.querySelector('[data-reviews-topic]');
    var allTopic = all ? all.getAttribute('data-reviews-topic') : null;

    section.classList.add('is-js-ready');

    pills.addEventListener('click', function (event) {
      var pill = event.target.closest('[data-reviews-topic]');
      if (!pill) return;

      var topic = pill.getAttribute('data-reviews-topic');

      pills.querySelectorAll('[data-reviews-topic]').forEach(function (el) {
        var on = el === pill;
        el.classList.toggle('is-active', on);
        el.setAttribute('aria-checked', on ? 'true' : 'false');
      });

      var shown = 0;
      cards.forEach(function (card) {
        /* The first pill is the show-everything one, whatever it is called. */
        var match = topic === allTopic || cardHasTopic(card, topic);
        card.hidden = !match;
        if (match) shown++;
      });

      if (empty) empty.hidden = shown > 0;
      rail.scrollLeft = 0;

      /* Filtering changes how much there is to scroll, so the bar and the
         arrows have to be recomputed or they describe the old set. */
      if (typeof section.cReviewsSyncSwiper === 'function') section.cReviewsSyncSwiper();
    });
  }

  /* Topics are a comma-separated list on the card; a pill matches when its
     label appears among them. Compared loosely so "Pet hair" and "pet hair"
     are the same thing to a merchant typing into the theme editor. */
  function cardHasTopic(card, topic) {
    var raw = card.getAttribute('data-reviews-card-topics') || '';
    return raw
      .split(',')
      .map(function (t) { return t.trim().toLowerCase(); })
      .indexOf(topic.trim().toLowerCase()) !== -1;
  }

  /* --- the widget's percentages --------------------------------------------- */

  function normalisePercentages(bars) {
    function run() {
      bars.querySelectorAll('.SA__review_num_ratings > span:last-child').forEach(function (span) {
        var match = span.textContent.match(/([\d.]+)\s*%/);
        if (!match) return;
        var value = parseFloat(match[1]);
        /* Floored at 1% for anything not actually zero: the bottom bands sit
           near 0.3%, and "0%" beside a visible bar reads as a bug. */
        var rounded = (value > 0 ? Math.max(1, Math.round(value)) : 0) + '%';
        if (span.textContent.trim() !== rounded) span.textContent = rounded;
      });
    }

    run();
    new MutationObserver(run).observe(bars, { childList: true, subtree: true });
  }

  /* The widget injects itself when its own script finishes, so wait for the
     bars to appear rather than assuming they are there — and give up instead
     of observing forever. */
  function whenSummaryReady(section, done) {
    var wrapper = section.querySelector('[data-reviews-widget]');
    if (!wrapper) return;

    var bars = wrapper.querySelector('.SA__review_bar_container');
    if (bars) {
      done(bars);
      return;
    }

    var settled = false;
    var observer = new MutationObserver(function () {
      var found = wrapper.querySelector('.SA__review_bar_container');
      if (!found) return;
      settled = true;
      observer.disconnect();
      done(found);
    });

    observer.observe(wrapper, { childList: true, subtree: true });
    window.setTimeout(function () {
      if (!settled) observer.disconnect();
    }, WAIT_MS);
  }

  function initAll() {
    document.querySelectorAll('[data-sl-id="c-reviews"]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.querySelector('[data-sl-id="c-reviews"]');
    if (section) initSection(section);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["c-ugc"] && !Shopify.designMode) return;
  try {
    
/* ===========================================================================
   Section script — turns the card rail into a swiper. Enhancement only.
   ===========================================================================

   Swiper the library is not an option here: it ships from a CDN and builds its
   layout at runtime, so under the script-stripping cloak described in
   AGENTS.md a visitor would get a pile of unstyled slides. Instead the rail is
   a CSS scroll-snap track that already swipes on touch, and this file adds the
   parts a mouse needs — grab-to-drag, arrows and a progress bar.

   Everything it adds is gated behind `is-js-ready` on the section, following
   the same contract as c-home-products: the controls stay hidden until this
   runs, so nobody is ever shown a dead arrow. Until then the rail keeps its
   native scrollbar, which is draggable and costs nothing.
   =========================================================================== */

(function () {
  'use strict';

  var DRAG_THRESHOLD = 5;

  function initSection(section) {
    if (section.dataset.cUgcReady === 'true') return;
    section.dataset.cUgcReady = 'true';

    var rail = section.querySelector('[data-ugc-rail]');
    if (!rail) return;

    var bar = section.querySelector('[data-ugc-bar]');
    var prev = section.querySelector('[data-ugc-prev]');
    var next = section.querySelector('[data-ugc-next]');

    section.classList.add('is-js-ready');

    /* One card plus the gap — the distance an arrow press should travel. */
    function step() {
      var first = rail.firstElementChild;
      if (!first) return rail.clientWidth;
      var gap = parseFloat(getComputedStyle(rail).columnGap) || 0;
      return first.getBoundingClientRect().width + gap;
    }

    function sync() {
      var max = rail.scrollWidth - rail.clientWidth;
      var ratio = max <= 1 ? 1 : rail.scrollLeft / max;
      var visible = Math.max(rail.clientWidth / rail.scrollWidth, 0.12);
      if (bar) {
        bar.style.width = visible * 100 + '%';
        bar.style.transform = 'translateX(' + ratio * (100 / visible - 100) + '%)';
      }
      if (prev) prev.disabled = rail.scrollLeft <= 1;
      if (next) next.disabled = rail.scrollLeft >= max - 1;
    }

    if (prev) {
      prev.addEventListener('click', function () {
        rail.scrollBy({ left: -step(), behavior: 'smooth' });
      });
    }
    if (next) {
      next.addEventListener('click', function () {
        rail.scrollBy({ left: step(), behavior: 'smooth' });
      });
    }

    rail.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync);
    sync();

    /* --- grab to drag ----------------------------------------------------
       Touch already swipes natively, so this is for the mouse. The cards flip
       on click, so a drag that crosses the threshold has to swallow the click
       it would otherwise end with — dragging the rail must never flip a card.
       -------------------------------------------------------------------- */
    var down = false;
    var moved = false;
    var startX = 0;
    var startScroll = 0;

    rail.classList.add('is-draggable');

    rail.addEventListener('pointerdown', function (event) {
      if (event.pointerType === 'touch' || event.button !== 0) return;
      down = true;
      moved = false;
      startX = event.clientX;
      startScroll = rail.scrollLeft;
    });

    rail.addEventListener('pointermove', function (event) {
      if (!down) return;
      var delta = event.clientX - startX;
      if (!moved && Math.abs(delta) < DRAG_THRESHOLD) return;
      moved = true;
      rail.classList.add('is-dragging');
      rail.scrollLeft = startScroll - delta;
    });

    function release() {
      down = false;
      rail.classList.remove('is-dragging');
    }

    rail.addEventListener('pointerup', release);
    rail.addEventListener('pointercancel', release);
    rail.addEventListener('pointerleave', release);

    rail.addEventListener(
      'click',
      function (event) {
        if (!moved) return;
        moved = false;
        event.preventDefault();
        event.stopPropagation();
      },
      true
    );
  }

  function initAll() {
    document.querySelectorAll('[data-sl-id="c-ugc"]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  /* The theme editor re-renders sections in place. */
  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.querySelector('[data-sl-id="c-ugc"]');
    if (section) initSection(section);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'related-products'
  var productRecommendationsSection = document.querySelector(".related-products");
  if (productRecommendationsSection === null) { return; }
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", productRecommendationsSection.dataset.url);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.innerHTML = container.querySelector(".related-products").innerHTML;
    }
  };
  request.send();
};
// fetch when section reloads in editor
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].related-products')) {
    loadProductRecommendationsIntoSection();
  }
});
// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();
})();
